import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ElectricMeterNewEditForm from './ElectricMeterNewEditForm';
// ----------------------------------------------------------------------

export default function ElectricMeterCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('ElectricMeter.AddTitle')}` : `${translate('ElectricMeter.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('ElectricMeter.CreateElectricMeter')}`
              : `${translate('ElectricMeter.EditElectricMeter')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ElectricMeter.ElectricMeterList')}`,
              href: PATH_DASHBOARD.ElectricMeter.list,
            },
            {
              name: !isEdit
                ? `${translate('ElectricMeter.New')}`
                : `${translate('ElectricMeter.Update')}`,
            },
          ]}
        />
        <ElectricMeterNewEditForm />
      </Container>
    </Page>
  );
}
